import React from 'react';
import Loadable from 'react-loadable';

const Carousel = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default Carousel;
